import { render } from "./newAccount.vue?vue&type=template&id=5298bfb3&scoped=true"
import script from "./newAccount.vue?vue&type=script&lang=js"
export * from "./newAccount.vue?vue&type=script&lang=js"

import "./newAccount.vue?vue&type=style&index=0&id=5298bfb3&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5298bfb3"]])

export default __exports__